// GetBNPLOrderStatus returns the payment status of an order placed with Buy now pay later
export const PaymentService_GetBNPLOrderStatusLazy = () =>
  import("./service.grpc").then((m) => m.PaymentService_GetBNPLOrderStatus);
PaymentService_GetBNPLOrderStatusLazy.method =
  "aysa_api.services.payment.PaymentService/GetBNPLOrderStatus" as const;

// GetPOAURL will return a URL a client should redirect to to initialize the Zalando Pay Order App.
// Whenever this EP is called we will store additional information on redis explicit for the POA, the POAData
// It is called from App. Web will only use the GetPOAToken.
export const PaymentService_GetPOAURLLazy = () =>
  import("./service.grpc").then((m) => m.PaymentService_GetPOAURL);
PaymentService_GetPOAURLLazy.method =
  "aysa_api.services.payment.PaymentService/GetPOAURL" as const;
